import React from 'react';
import { FaUser } from 'react-icons/fa';

const ContactSection = () => {
  return (
    <div className="bg-white px-4 pt-7 pb-5 rounded-lg">
      {/* Horizontal Line */}
      <div className="border-t border-gray-300 mb-4"></div>

      {/* Buttons and Contact Info Section */}
      <div className="flex items-start justify-between">
        {/* Buttons Section */}
        <div className="flex items-center space-x-4">
          {/* Contact Owner Button */}
          <button className="bg-[#2b463c] text-white font-medium px-4 py-2 rounded-full hover:bg-red-700">
            Contact Owner
          </button>
          {/* Get Phone Number Button */}
          <button className="border border-red-600 text-red-600 font-medium px-4 py-2 rounded-full hover:bg-red-50">
            Get Phone No.
          </button>
        </div>

        {/* Last Contact Info */}
        <div className="flex items-center space-x-2 text-gray-600">
          <FaUser className="text-teal-500" />
          <span className="text-[#303030] text-sm">Last contact made 3 days ago</span>
        </div>
      </div>
    </div>
  );
};

export default ContactSection;
